import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { CreatorCell } from "@/pages/ReportsPage/components/molecules/CreatorCell"

export const getCreatorColumn = () => ({
  title: "Creator",
  width: 70,
  className: "center-align-tab-template-component",
  render: CreatorCell,
  ...getDefaultColumnParams("creator")
})
